import { notificationService } from '../../../lib/services.notification';
import type { StockSummary } from '../types';

export async function createLowStockAlerts(lowStockItems: StockSummary[]): Promise<void> {
  const adminUserId = '00000000-0000-0000-0000-000000000000';
  
  for (const item of lowStockItems) {
    try {
      await notificationService.create({
        patient_id: adminUserId,
        notification_type: 'email',
        channel: 'system',
        recipient: 'pharmacy@hospital.local',
        subject: `Low Stock Alert: ${item.medicineName}`,
        message: `Medicine "${item.medicineName}" is running low. Current stock: ${item.totalStock}, Reorder level: ${item.reorderLevel}. Please reorder immediately.`,
        status: 'pending',
        metadata: {
          medicine_id: item.medicineId,
          medicine_name: item.medicineName,
          current_stock: item.totalStock,
          reorder_level: item.reorderLevel,
          alert_type: 'low_stock'
        }
      });
    } catch (error) {
      console.error(`Failed to create low stock alert for ${item.medicineName}:`, error);
    }
  }
}

export async function createExpiryAlerts(nearExpiryItems: StockSummary[]): Promise<void> {
  const adminUserId = '00000000-0000-0000-0000-000000000000';
  
  for (const item of nearExpiryItems) {
    if (!item.nearestExpiry) continue;
    
    try {
      const expiryDate = new Date(item.nearestExpiry);
      const daysUntilExpiry = Math.ceil((expiryDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
      
      await notificationService.create({
        patient_id: adminUserId,
        notification_type: 'email',
        channel: 'system',
        recipient: 'pharmacy@hospital.local',
        subject: `Expiry Alert: ${item.medicineName}`,
        message: `Medicine "${item.medicineName}" is expiring soon (${daysUntilExpiry} days). Expiry date: ${expiryDate.toLocaleDateString()}. Please take action to minimize wastage.`,
        status: 'pending',
        metadata: {
          medicine_id: item.medicineId,
          medicine_name: item.medicineName,
          expiry_date: item.nearestExpiry,
          days_until_expiry: daysUntilExpiry,
          alert_type: 'near_expiry'
        }
      });
    } catch (error) {
      console.error(`Failed to create expiry alert for ${item.medicineName}:`, error);
    }
  }
}

export async function checkAndCreatePharmacyAlerts(stockSummary: StockSummary[]): Promise<void> {
  const lowStockItems = stockSummary.filter(item => item.isLowStock);
  const nearExpiryItems = stockSummary.filter(item => item.isNearExpiry);
  
  await Promise.allSettled([
    createLowStockAlerts(lowStockItems),
    createExpiryAlerts(nearExpiryItems)
  ]);
}
